export const linkTypes = {
	small: 'small',
	base: 'base'
};